var render, staticRenderFns
import script from "./CrtWebEmail.vue?vue&type=script&lang=js&"
export * from "./CrtWebEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bff430e')) {
      api.createRecord('8bff430e', component.options)
    } else {
      api.reload('8bff430e', component.options)
    }
    
  }
}
component.options.__file = "src/views/Configuration/WebEmail/CrtWebEmail.vue"
export default component.exports